import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import {
  getGroupListSuccess, getGroupListError,
  getGroupDeviceDataSuccess, getGroupItemError,
  toggleGroupListLoading, toggleGroupListRefreshing,
  toggleTabChangeRefreshing, updateSelectedTab,
} from 'store/groupList/actions';
import {
  getHistoryDataSuccess, getHistoryDataError,
  toggleRoomDetailLoading,
} from 'store/roomDetail/actions';
import { startWithEndWith, NO_OP } from 'middleware/utils';
import {
  GET_DATA_LIST,
  SET_NOTIFICATION_READ,
  GET_GROUP_DEVICE_DATA,
  GET_HISTORY_DATA,
  GET_GROUP_DEVICE_DATA_ON_TAB_CHANGE,
} from './actions';

const getDataListEpic = (action$, state$, { dataRequest }) => action$.pipe(
  ofType(GET_DATA_LIST),
  mergeMap(() => dataRequest.getData$().pipe(
    mergeMap((response) => {
      const { data } = response;
      return of(getGroupListSuccess(data));
    }),
    catchError(error => of(getGroupListError(error))),
  )),
  catchError(error => of(getGroupListError(error))),
);

const getGroupDeviceDataOnTabChangeEpic = (action$, state$, { deviceRequest }) => action$.pipe(
  ofType(GET_GROUP_DEVICE_DATA_ON_TAB_CHANGE),
  mergeMap((params) => {
    const { payload } = params;
    const { groupId } = payload;
    return deviceRequest.getGroupDeviceData$(groupId).pipe(
      mergeMap((response) => {
        const { data } = response;
        return of(getGroupDeviceDataSuccess(groupId, data));
      }),
      catchError(error => of(getGroupItemError(error))),
      startWithEndWith(updateSelectedTab(groupId), toggleTabChangeRefreshing(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

const getGroupDeviceDataEpic = (action$, state, { deviceRequest }) => action$.pipe(
  ofType(GET_GROUP_DEVICE_DATA),
  mergeMap((params) => {
    const isRefreshing = state.value.groupListReducer.groupRefreshing;
    if (isRefreshing) {
      return of(NO_OP);
    }
    const { payload } = params;
    const { groupId } = payload;
    return deviceRequest.getGroupDeviceData$(groupId).pipe(
      mergeMap((response) => {
        const { data } = response;
        return of(getGroupDeviceDataSuccess(groupId, data));
      }),
      catchError(error => of(getGroupItemError(error))),
      startWithEndWith(toggleGroupListRefreshing(true), toggleGroupListRefreshing(false)),
      startWithEndWith(toggleGroupListLoading(true), toggleGroupListLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

const setNotificationReadEpic = (action$, state$, { notificationRequest }) => action$.pipe(
  ofType(SET_NOTIFICATION_READ),
  mergeMap((params) => {
    const { payload } = params;
    const { id } = payload;
    return notificationRequest.markNotificationRead$(id).pipe(
      mergeMap(() => of(NO_OP)),
      catchError(() => of(NO_OP)),
    );
  }),
  catchError(() => of(NO_OP)),
);

const getHistoryDataEpic = (action$, state$, { deviceRequest }) => action$.pipe(
  ofType(GET_HISTORY_DATA),
  mergeMap((params) => {
    const { payload } = params;
    const {
      from, to, did, dataField,
    } = payload;
    return deviceRequest.getDeviceHistoryData$(from, to, did, dataField).pipe(
      mergeMap((response) => {
        const { data } = response;
        return of(getHistoryDataSuccess(data, dataField));
      }),
      catchError(error => of(getHistoryDataError(error))),
      startWithEndWith(toggleRoomDetailLoading(true), toggleRoomDetailLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

export default combineEpics(
  getDataListEpic,
  setNotificationReadEpic,
  getGroupDeviceDataEpic,
  getHistoryDataEpic,
  getGroupDeviceDataOnTabChangeEpic,
);
